import type { Project, Submission, User } from "./types";

const now = Date.now();
const future = (days: number) => new Date(now + days * 86400000).toISOString();
const past = (days: number) => new Date(now - days * 86400000).toISOString();

export const demoUsers: User[] = [
  { id: "u-super", username: "admin", displayName: "超级管理员", role: "super_admin", active: true, createdAt: past(120) },
  { id: "u-lin", username: "lin", displayName: "林制片", role: "sub_admin", active: true, createdAt: past(40) },
  { id: "u-zhao", username: "zhao", displayName: "赵导演", role: "sub_admin", active: false, pendingApproval: false, adminNote: "外部合作导演，暂时停用", createdAt: past(18) },
  { id: "u-wait", username: "wanglaoshi", displayName: "王老师", role: "sub_admin", active: false, pendingApproval: true, adminNote: "自行注册，待核对身份", createdAt: past(.25) },
];

export const demoProjects: Project[] = [
  {
    id: "p-mozun", name: "《别说话，魔尊要开大了》角色试音", description: "请按角色台词试录，文件名使用“角色名_CV缩写”。环境安静，无需降噪和配乐。",
    deadline: future(4), ownerId: "u-lin", ownerName: "林制片", assignedAdmins: [], publicToken: "demo-project", status: "accepting",
    createdAt: past(3), submissions: 126, fileCount: 214, bytes: 684 * 1024 * 1024, roles: ["墨渊", "阿梨", "旁白", "天帝"],
  },
  {
    id: "p-city", name: "《雾城来信》先导集试音", description: "都市悬疑短剧试音。", deadline: past(2), ownerId: "u-super", ownerName: "超级管理员", assignedAdmins: [{ id: "u-lin", username: "lin", displayName: "林制片" }],
    publicToken: "fog-city", status: "closed", createdAt: past(12), submissions: 89, fileCount: 137, bytes: 391 * 1024 * 1024,
    roles: ["沈砚", "林夏", "周警官"],
  },
  {
    id: "p-old", name: "《星河旧梦》补录招募", description: "已完成收集。", deadline: past(35), ownerId: "u-lin", ownerName: "林制片", assignedAdmins: [],
    publicToken: "star-dream", status: "retention_pending", createdAt: past(50), submissions: 54, fileCount: 72, bytes: 208 * 1024 * 1024,
    roles: ["云昭", "小满"],
  },
];

const tinyWav = "data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQAAAAA=";
export const demoSubmissions: Submission[] = [
  {
    id: "S260710001", projectId: "p-mozun", wechatNickname: "小羽", wechatId: "xiaoyu_voice", phone: "138****2356",
    createdAt: past(0.08), updatedAt: past(0.08), files: [
      { id: "f-001", submissionId: "S260710001", originalName: "阿梨_XY.mp3", roleName: "阿梨", cvAbbr: "XY", size: 2854321, sha256: "a1".repeat(32), mime: "audio/mpeg", createdAt: past(0.08), cloudStatus: "ready", previewUrl: tinyWav },
      { id: "f-002", submissionId: "S260710001", originalName: "旁白_XY.mp3", roleName: "旁白", cvAbbr: "XY", size: 1732401, sha256: "b2".repeat(32), mime: "audio/mpeg", createdAt: past(0.08), cloudStatus: "ready", previewUrl: tinyWav },
    ],
  },
  {
    id: "S260709118", projectId: "p-mozun", wechatNickname: "北辰CV", wechatId: "beichen_cv", phone: "186****9012",
    createdAt: past(0.7), updatedAt: past(0.7), files: [
      { id: "f-003", submissionId: "S260709118", originalName: "墨渊-BC.mp3", roleName: "墨渊", cvAbbr: "BC", size: 3910022, sha256: "c3".repeat(32), mime: "audio/mpeg", createdAt: past(0.7), cloudStatus: "ready", previewUrl: tinyWav },
    ],
  },
  {
    id: "S260709084", projectId: "p-mozun", wechatNickname: "十二", wechatId: "voice12", phone: "159****6671",
    createdAt: past(1.1), updatedAt: past(1.1), files: [
      { id: "f-004", submissionId: "S260709084", originalName: "天帝+12.mp3", roleName: "天帝", cvAbbr: "12", size: 2248190, sha256: "d4".repeat(32), mime: "audio/mpeg", createdAt: past(1.1), cloudStatus: "ready", previewUrl: tinyWav },
    ],
  },
];

export const demoAudit = [
  { id: "a0", time: past(0.01), actorId: "u-super", actor: "超级管理员", action: "分配项目", detail: "《雾城来信》先导集试音 → 林制片" },
  { id: "a1", time: past(0.04), actorId: "u-lin", actor: "林制片", action: "同步项目", detail: "新增 18 个，跳过 196 个" },
  { id: "a2", time: past(0.3), actorId: "u-super", actor: "超级管理员", action: "重置子账号密码", detail: "账号：zhao" },
  { id: "a3", time: past(1), actorId: "u-lin", actor: "林制片", action: "合并角色", detail: "旁百 → 旁白" },
];
